module.exports = __webpack_public_path__ + "static/media/ROPEZE_ABOUT2.60c28575.png";